<div class="lg-page">

    <!-- Left: branding panel -->
    <div class="lg-left">
        <img src="assets/images/login-bg.png" alt="Background" class="lg-bg" />
        <div class="lg-overlay"></div>
        <div class="lg-brand">
            <p class="lg-welcome">WELCOME BACK TO</p>
            <img src="assets/images/yaldi.svg" alt="Yaldi Logo" class="lg-logo" />
            <p class="lg-tagline">
                Monitor every vehicle in real-time, resolve<br />
                incidents fast, and grow revenue — all from a<br />
                single command center.
            </p>
        </div>
    </div>

    <!-- Right: form panel -->
    <div class="lg-right">
        <div class="lg-form-wrap">
            <h2 class="lg-title">Sign in to your account</h2>
            <p class="lg-subtitle">Enter your credentials to continue</p>

            <form [formGroup]="loginForm" class="lg-form">

                <div class="lg-field">
                    <label class="lg-label" for="emailOrPhone">
                        <i class="fa-regular fa-envelope lg-field-icon"></i>
                        Email or Phone
                    </label>
                    <input id="emailOrPhone" pInputText class="lg-input" formControlName="emailOrPhone"
                        placeholder="Email or Phone" />
                    @if (loginForm.get('emailOrPhone')?.errors?.['required'] && (loginForm.get('emailOrPhone')?.touched || isSubmitted)) {
                        <small class="lg-error">This field is required</small>
                    }
                    @if (loginForm.get('emailOrPhone')?.errors?.['phoneOrEmail'] && (loginForm.get('emailOrPhone')?.touched || isSubmitted)) {
                        <small class="lg-error">Enter a valid phone number or email</small>
                    }
                </div>

                <div class="lg-field">
                    <label class="lg-label" for="password">
                        <i class="fa-solid fa-lock lg-field-icon"></i>
                        Password
                    </label>
                    <p-password id="password" formControlName="password" placeholder="Password"
                        [feedback]="false" [toggleMask]="true"
                        styleClass="lg-password" inputStyleClass="lg-input" />
                    @if (loginForm.get('password')?.errors?.['required'] && (loginForm.get('password')?.touched || isSubmitted)) {
                        <small class="lg-error">This field is required</small>
                    }
                </div>

                <div class="lg-remember">
                    <p-checkbox inputId="rememberMe" binary="true" formControlName="rememberMe" />
                    <label for="rememberMe">Remember me</label>
                </div>

                <button type="button" class="lg-btn" (click)="login()">
                    Log In Now &nbsp; <i class="fa-solid fa-arrow-right"></i>
                </button>

            </form>
        </div>
    </div>

</div>
